var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4491_178717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4032 5.6763L17.3319 4.60503C16.5356 3.80874 15.1472 3.80874 14.3503 4.60503L12.9661 5.99048C12.9649 5.99107 12.9631 5.99341 12.9614 5.99399C12.9614 5.99517 12.9584 5.99692 12.9573 5.99751L4.70889 14.2453C4.61821 14.336 4.5597 14.4542 4.54156 14.5811L4.00622 18.3291C3.9793 18.514 4.04074 18.7006 4.17179 18.8317C4.28354 18.9458 4.43508 19.0078 4.59129 19.0078C4.61996 19.0078 4.64863 19.0043 4.67613 19.0008L8.42529 18.466C8.55225 18.4485 8.67043 18.3882 8.76053 18.2993L17.0072 10.0497L17.0101 10.0462C17.0118 10.0451 17.013 10.0427 17.0148 10.041L18.4002 8.6555C18.7992 8.25765 19.0187 7.72933 19.0187 7.16648C19.0187 6.60364 18.8004 6.07415 18.4032 5.6763ZM8.06254 17.3193L5.29163 17.7171L5.68714 14.9451L13.3797 7.25425L15.7551 9.62848L8.06254 17.3193ZM17.5624 7.81767L16.5941 8.7889L14.2187 6.41466L15.1899 5.44344C15.5375 5.09415 16.1442 5.09415 16.4935 5.44344L17.5636 6.51413C17.7403 6.68906 17.8345 6.92017 17.8345 7.16707C17.8333 7.4128 17.7385 7.64508 17.5624 7.81767Z",
    fill: "#2B343E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4491_178717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.0078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGrey);
export default __webpack_public_path__ + "static/media/editIconGrey.da90f69a1c509a105a4b8a3c78b1c10e.svg";
export { ForwardRef as ReactComponent };